































import { Component, Vue } from 'vue-property-decorator'

@Component
export default class ViewNotFound extends Vue {
  retryAfter = 0

  mounted() {
    this.retryAfter = Number(this.$route.query.retryAfter)
  }

  get canShowAsMaintenance() {
    return !!this.retryAfter
  }
}
